<!--
 * @Author: baiwei
 * @Date: 2020-03-26 17:12:46
 * @LastEditors: baiwei
 * @LastEditTime: 2020-05-25 10:35:22
 * @Description: 我的配额
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
 -->
<template>
    <div>
        <helpInfo :helpData='helpData'>
            <Button slot="slotR"
                    type="primary"
                    :disabled="!hasPermission('CG01')"
                    @click="$router.push('/mgt/workorder?create=true')">{{$t('申请')}}</Button>
        </helpInfo>
        <div class="quota-pack">
            <!-- <div class="button-pack">
                <Button type="primary"
                        @click="$refs.adjustQuota.open()">申请</Button>
            </div> -->

            <Tabs v-model="envTabVal"
                  @on-click="getQuota"
                  v-if="envData.length > 1"
                  type="card"
                  class="tab-pack">
                <TabPane v-for="(env, index) in envData"
                         :key="`env${index}`"
                         :label="env.cloudEnvName"
                         :name="env.cloudEnvAccountId + ''"></TabPane>
            </Tabs>
            <div class="env-quota">
                <div v-for="(quotasItem, i) in quotasList"
                     :key="`quotasItem${i}`"
                     class="env-quota-item">
                    <h4 class="title">{{quotasItem.resourceTypeName}}</h4>
                    <!-- quotasName[key] -->
                    <div class="quotas-pack">
                        <ul class="label-pack">
                            <li v-for="(quotas, ii) in quotasItem.list"
                                :key="`quotaslabel${i}${ii}`">
                                <Poptip trigger="hover"
                                        :disabled="quotas.classify==='all'">
                                    <div slot="content"
                                         style="text-align: center">{{ quotas.classifyName}}</div>
                                    {{quotas.classify==='all'?(quotas.quotaName + (quotas.subpropertyName || '')) + `(${quotas.unit})`:`${quotas.attr.display}(${quotas.unit})`}}：
                                </Poptip>
                            </li>
                        </ul>
                        <ul class="value-pack">
                            <li v-for="(quotas, ii) in quotasItem.list"
                                :key="`quotasval${i}${ii}`"
                                class="quota-content">
                                <div v-if="quotas.scope==='instance'">
                                    <Poptip trigger="hover"
                                            :disabled="!quotas.attr.list.length">
                                        <ul slot="content">
                                            <li v-for="(item, i) in quotas.attr.list"
                                                :key="`attrlist${i}`">{{item.name}}：{{item.used + '/' + item.value}}</li>
                                        </ul>
                                        <Progress :percent="compute(quotas.attr.used*100/quotas.attr.value)"
                                                  :stroke-width="6"
                                                  hide-info />
                                    </Poptip>
                                    <span class="right-hint">
                                        {{quotas.attr.used + '/' + quotas.attr.value}}
                                        <Poptip trigger="hover"
                                                class="hint-pop">
                                            <div slot="content">{{$t('当前配额限制为【资源实例】针对具体服务下属资源的数量')}}</div>
                                            <i class="icon-prompt-1-o"></i>
                                        </Poptip>
                                    </span>
                                </div>
                                <div v-else>
                                    <!-- <Poptip trigger="hover">
                                        <div slot="content">{{quotas.classify==='all' ? `已用配额${quotas.usedQuota}/总配额${quotas.quotaValue==='1'? $t('无限制'): quotas.value}` + `(${quotas.unit})`:quotas.classifyName}}</div>
                                        <Progress :percent="quotas.quotaValue==='1'? 0: compute(quotas.usedQuota*100/quotas.value)" :stroke-width="6" hide-info />
                                    </Poptip> -->
                                    <Poptip trigger="hover">
                                        <div slot="content">{{$t('已用配额')+quotas.usedQuota+'/'+$t('总配额')+(quotas.quotaValue==='1'? $t('无限制'): quotas.value)+`(${quotas.unit})`}}</div>
                                        <Progress :percent="quotas.quotaValue==='1'? 0: compute(quotas.usedQuota*100/quotas.value)"
                                                  :stroke-width="6"
                                                  hide-info />
                                    </Poptip>
                                    <span class="right-hint">{{quotas.usedQuota}}/{{quotas.quotaValue==='1'? $t('无限制'): quotas.value}}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <noData v-if="!quotasList.length"></noData>
            </div>
        </div>
    </div>
</template>
<script>
import helpInfo from '@c/basic/helpinfo'
import noData from '@c/basic/nodata'
import API from '@/service/api.js'
export default {
    name: 'quota',
    components: {
        helpInfo,
        noData
    },
    data () {
        return {
            helpData: {
                modelName: this.$t('我的配额')
            },
            split: 0.2,
            searchVal: null,
            envTabVal: null,
            envData: [],
            quotasList: []
        }
    },
    created () {
        this.getEnvs()
    },
    methods: {
        getEnvs () { // 获取当前组织下的云环境
            this.axios.get(this.urlFormat(API.QUOTA_ENV_SWITCH, true)).then((res) => {
                this.envData = res
                if (res.length) {
                    this.envTabVal = this.envTabVal || `${res[0].cloudEnvAccountId}`
                    this.getQuota()
                }
            })
        },
        compute (num) {
            return num > 100 ? 100 : num
        },
        getQuota () { // 获取云环境下的配额
            const env = this.envData.find(e => e.cloudEnvAccountId === Number(this.envTabVal))
            this.activeEnv = Object.assign(env, { quotaCtrVal: env.status === 1 }) // 0是关,1是开
            this.axios.get(this.urlFormat(API.QUOTA_TENANT, false), {
                params: {
                    // orgSid: orgSid,
                    cloudEnvAccountId: this.envTabVal
                }
            }).then((res) => {
                this.quotasList = res
            })
        }
    }
}
</script>

<style lang="less" scoped>
.quota-pack {
    // display: flex;
    // min-height: calc(~'100% - 47px');
    // background-color: #f5f6f7;
    padding: 15px;
}
.env-quota {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    // background-color: #f5f6f7;
    padding: 10px 0;
    .env-quota-item {
        width: calc(~"50% - 7.5px");
        margin: 7.5px 0;
        padding-bottom: 10px;
        min-height: 195px;
        background-color: #fff;
        border: 1px solid #e9e9e9;
        .title {
            padding: 10px 15px 5px 15px;
        }
        .quotas-pack {
            display: flex;
            color: #777;
            li {
                height: 30px;
                padding: 3px 0;
            }
            .label-pack {
                display: inline-block;
                text-align: right;
                flex-shrink: 0;
                white-space: nowrap;
                padding-left: 10px;
                min-width: 120px;
            }
            .value-pack {
                flex-grow: 1;
                li {
                    position: relative;
                    padding-right: 90px;
                    .right-hint {
                        display: flex;
                        width: 80px;
                        padding: 3px 0;
                        display: inline-block;
                        position: absolute;
                        right: 0;
                        top: 0;
                        .icon-prompt-1-o {
                            // margin-left: 5px;
                            color: #2d8cf0;
                            vertical-align: middle;
                        }
                    }
                }
            }
        }
    }
    .no-data {
        width: 100%;
        text-align: center;
        padding: 30px;
        .no-data-img {
            display: inline-block;
            width: 36px;
            height: 36px;
            background: url(../../../assets/images/console/no-data.png)
                no-repeat;
            background-size: 100%;
            vertical-align: middle;
            margin-right: 15px;
        }
    }
}
</style>

<style lang="less">
.quota-pack {
    .tab-pack {
        padding-bottom: 0;
        .ivu-tabs-bar {
            margin-bottom: 0;
        }
    }
    .ivu-progress-inner {
        border-radius: unset;
    }
    .ivu-progress-bg {
        border-radius: unset;
        background-color: #1f68b3 !important;
    }
    .quota-content {
        .ivu-poptip {
            width: 100%;
            .ivu-poptip-rel {
                width: 100%;
            }
            .ivu-poptip-popper {
                min-width: 50px;
            }
        }
        .hint-pop.ivu-poptip {
            width: auto;
        }
    }
}
</style>
